import {CellBuilderFlagIcon} from "/@back@/commons/widgets/grid-libs.js";
import {GridColDef, IGridDataRow} from "/@back@/commons/widgets/grid-core.js";
import {IReg, IRegPointer, REG} from "/@lib@/commons/registry.js";
import {Button, ButtonToggle} from "/@back@/commons/widgets/buttons.js";
import {DOM, JSX} from "/@lib@/commons/xml/dom.js";
import {EDrvState} from "/@lib@/wsp/src.js";
import {IWspUiEnv} from "/@lib@/wsp/wsp.js";
import {OUiCritInit, UiCritArea, UiCritBase} from "/@back@/wsp/widgets/search/uiCrit.js";
import {ESearchExportColumnStatus, ISearchCrit, SearchDrvStates, SearchExportColumn, SearchFuncTranslateStr} from "/@lib@/wsp/search.js";
import {DOMSH} from "/@lib@/commons/xml/domsh.js";
import {RibbonBase} from "/@back@/wsp/widgets/ribbon/ribbon.js";
import {TemplateResult} from "/@res@/litHtml/lib/template-result.js";
import {renderAppend, xhtml} from "/@lib@/commons/utils/htmlLit.js";
import {SrcAction} from "/@back@/wsp/actions/srcActions.js";
import {IShortDescCtx} from "/@lib@/wsp/item.js";
import {POPUP, PopupTooltip} from "/@back@/commons/widgets/popups.js";
import {IView} from "/@lib@/commons/views.js";
import {BarActions, OBarActionsInit} from "/@back@/commons/widgets/bars.js";
import {WSP_DRV} from "/@lib@/wsp/drv.js";
import {WSP_L10N} from "/@lib@/wsp/l10n.js";
import {NavigatorArea} from "/@back@/wsp/areas/wspWorkbench.js";
import {Navigator, NavigatorFacetText} from "/@back@/wsp/views/navigator.js";
import {JLastDatas} from "/@lib@/commons/lastDatas.js";
import {LANG} from "/@lib@/commons/lang.js";

export class CellBuilderDrvFlag extends CellBuilderFlagIcon {

	iconWidth = ".8rem";

	iconFilter = "var(--filter)";

	constructor(dataKey: string, protected l10nCtx = false) {
		super(dataKey);
	}

	protected _buildContent(row: IGridDataRow, root: HTMLElement): HTMLElement {
		DOM.addClass(root, 'center');
		return super._buildContent(row, root);
	}

	protected _getIcon(row: IGridDataRow): string {
		const st = super._getValue(row);
		return st ? "--drv-" + st + "-url" : "";
	}

	protected _getValue(row: IGridDataRow): any {
		const st = super._getValue(row);
		return st ? WSP_DRV.getDrvStateLabel(st as EDrvState, this.l10nCtx) : "";
	}
}

REG.reg.registerSkin("wsp-explorer/grid/drv", 1, /* language=CSS */ `
	:host {
		--drv-notOverriden-url: url("/@skin@/wsp/objects/drvState/notOverriden.svg");
	  --drv-notOverridenDone-url: url("/@skin@/wsp/objects/drvState/notOverridenDone.svg");
	  --drv-notOverridenDirty-url: url("/@skin@/wsp/objects/drvState/notOverridenDirty.svg");
	  --drv-overridenNew-url: url("/@skin@/wsp/objects/drvState/overridenNew.svg");
	  --drv-overridenDone-url: url("/@skin@/wsp/objects/drvState/overridenDone.svg");
	  --drv-overridenDirty-url: url("/@skin@/wsp/objects/drvState/overridenDirty.svg");
	  --drv-createdNew-url: url("/@skin@/wsp/objects/drvState/createdNew.svg");
	  --drv-createdDone-url: url("/@skin@/wsp/objects/drvState/createdDone.svg");
	  --drv-createdDirty-url: url("/@skin@/wsp/objects/drvState/createdDirty.svg");
  }

  .colW.drv {
	  border: none;
  }
`);


/**
 *
 */
export class DeleteDrvOvr extends SrcAction<IShortDescCtx> {
	static SINGLETON = new DeleteDrvOvr();

	constructor() {
		super('deleteDrvOvr');
		this._group = "edit";
		this._icon = "/@skin@/wsp/actions/drvDeleteOvr.svg";
		this.atLeastOne = true;
		this.isNotRemoved = false;
		this._enableSrcPerms = ["action.drv#deleteOvr"];
	}

	getLabel(ctx: IShortDescCtx): string {
		const wspDefProps = ctx.reg.env.wsp.wspDefProps;
		const isWspL10n = WSP_L10N.isL10n(wspDefProps);
		if (ctx.shortDescs.length === 0) return isWspL10n ? "Supprimer toutes les traductions" : "Supprimer toutes les surcharges";
		return isWspL10n ? "Supprimer les traductions" : "Supprimer les surcharges";
	}

	isEnabled(ctx: IShortDescCtx): boolean {
		if (ctx.shortDescs.some((sd) => !sd.drvState?.startsWith("overriden"))) return false;
		return super.isEnabled(ctx);
	}

	async execute(ctx: IShortDescCtx, ev?: Event) {
		if (await this.confirm(ctx, ev)) {
			await WSP_DRV.srcDeleteOverride(ctx.reg.env.wsp, ctx.emitter, ctx.shortDescs);
		}
	}

	confirm(ctx: IShortDescCtx, ev?: Event): Promise<boolean> {
		const wspDefProps = ctx.reg.env.wsp.wspDefProps;
		const isWspL10n = WSP_L10N.isL10n(wspDefProps);
		const count = ctx.shortDescs.length;
		if (count === 0) return POPUP.confirm(isWspL10n ? "Confirmez la suppression de toutes les traductions de l'atelier. Les contenus originaux seront restaurés." : "Confirmez la suppression de toutes les surcharges de l'atelier. Les contenus originaux seront restaurés.", ctx.emitter, {okLbl: isWspL10n ? "Supprimer les traductions" : "Supprimer les surcharges"});
		return POPUP.confirm(isWspL10n ? "Confirmez la suppression des traductions. Les contenus originaux seront restaurés." : "Confirmez la suppression des surcharges. Les contenus originaux seront restaurés.", ctx.emitter, {okLbl: isWspL10n ? "Supprimer les traductions" : "Supprimer les surcharges"});
	}
}

REG.reg.registerSvc('drv/deleteDrvOvrAction', 1, DeleteDrvOvr.SINGLETON);

/**
 *
 */
export class MarkDrvDone extends SrcAction<IShortDescCtx> {
	static SINGLETON = new MarkDrvDone();

	constructor() {
		super('markDrvDone');
		this._group = "edit";
		this._icon = "/@skin@/wsp/actions/drvDone.svg";
		this.atLeastOne = true;
		this.isNotRemoved = false;
		this._enableSrcPerms = ["action.drv#markDone"];
	}

	getLabel(ctx: IShortDescCtx): string {
		const wspDefProps = ctx.reg.env.wsp.wspDefProps;
		const isWspL10n = WSP_L10N.isL10n(wspDefProps);
		return isWspL10n ? "Marquer la traduction achevée" : "Marquer la dérivation achevée";
	}

	isEnabled(ctx: IShortDescCtx): boolean {
		if (ctx.shortDescs.some((sd) => !!sd.drvState?.endsWith("Done"))) return false;
		return super.isEnabled(ctx);
	}

	async execute(ctx: IShortDescCtx, ev?: Event) {
		const wsp = ctx.reg.env.wsp;
		if (await this.confirm(ctx, ev)) {
			await WSP_DRV.srcMarkDrvDone(ctx.reg.env.wsp, ctx.emitter, ctx.shortDescs);
		}
	}

	confirm(ctx: IShortDescCtx, ev?: Event): Promise<boolean> {
		const wspDefProps = ctx.reg.env.wsp.wspDefProps;
		const isWspL10n = WSP_L10N.isL10n(wspDefProps);
		return POPUP.confirm(isWspL10n ? "Confirmez le marquage \"achevé\" de la traduction." : "Confirmez le marquage \"achevé\" de la dérivation.", ctx.emitter, {okLbl: "Marquer \"achevé\""});
	}
}

REG.reg.registerSvc('drv/markDrvDoneAction', 1, MarkDrvDone.SINGLETON);

/**
 *
 */
export class RibbonDrv extends RibbonBase {

	template(rib: RibbonDrv): TemplateResult {
		const wspDefProps = rib.reg.env.wsp.wspDefProps;
		const isWspL10n = WSP_L10N.isL10n(wspDefProps);
		return xhtml`<div class="smallTi">${isWspL10n ? "Calque de traduction" : "Calque de dérivation"}</div><div id="st" data-drv-state="${rib.reg.env.longDesc.drvState}"><img id="ico"/><div class="layer">${WSP_DRV.getDrvStateLayer(rib.reg.env.longDesc.drvState, isWspL10n)}</div><div class="done">${WSP_DRV.getDrvStateDone(rib.reg.env.longDesc.drvState)}</div></div>`;
	}

	_tooltip(this: void, rib: RibbonDrv, tooltip: PopupTooltip): IView | null {
		return <div id="ttRoot">
			<BarActions class="vertical" î={{
				reg: rib.reg,
				actions: [rib.reg.getSvc('drv/markDrvDoneAction'), rib.reg.getSvc('drv/deleteDrvOvrAction')],
				actionContext: rib.shortDescCtx,
				uiContext: "dialog",
				disableFullOverlay: true
			} as OBarActionsInit<IShortDescCtx>}/>
		</div>;
	}

	protected _initialize(init: any): void {
		super._initialize(init);
		this.reg.env.longDescChange.add(this.refresh.bind(this));
		this.setTooltip(this._tooltip, true);
	}

	protected _refresh() {
		if (!this.hidden) renderAppend(this.template(this), this.shadowRoot);
	}
}

REG.reg.registerSkin('wsp-rib-drv', 1, /* language=CSS */ `
	:host {
		flex: 0 1 auto;
		margin: 0 .2em;
		--drv-notOverriden-url: url(/@skin@/wsp/objects/drvState/notOverriden.svg);
		--drv-notOverridenDone-url: url(/@skin@/wsp/objects/drvState/notOverridenDone.svg);
		--drv-notOverridenDirty-url: url(/@skin@/wsp/objects/drvState/notOverridenDirty.svg);
		--drv-overridenNew-url: url(/@skin@/wsp/objects/drvState/overridenNew.svg);
		--drv-overridenDone-url: url(/@skin@/wsp/objects/drvState/overridenDone.svg);
		--drv-overridenDirty-url: url(/@skin@/wsp/objects/drvState/overridenDirty.svg);
		--drv-createdNew-url: url(/@skin@/wsp/objects/drvState/createdNew.svg);
		--drv-createdDone-url: url(/@skin@/wsp/objects/drvState/createdDone.svg);
		--drv-createdDirty-url: url(/@skin@/wsp/objects/drvState/createdDirty.svg);
	}


	#st {
		display: grid;
		grid-template-columns: min-content 1fr;
		grid-template-rows: min-content min-content;
		gap: 0px 0px;
		grid-template-areas:
    "ico layer"
    "ico done";
	}

	#layer, #done {
		flex: 1 0 auto;
		color: var(--alt1-color);
		font-weight: bold;
	}

	#layer {
		grid-area: layer;
	}

	#done {
		grid-area: done;
	}

	#ico {
		grid-area: ico;
		align-self: center;
		width: 1em;
		height: 1em;
		margin-inline-end: 0.2em;
	  filter: var(--filter);
	}

	#st[data-drv-state='notOverriden'] > #ico {
		content: var(--drv-notOverriden-url);
	}

	#st[data-drv-state='notOverridenDone'] > #ico {
		content: var(--drv-notOverridenDone-url);
	}

	#st[data-drv-state='notOverridenDirty'] > #ico {
		content: var(--drv-notOverridenDirty-url);
	}

	#st[data-drv-state='overridenNew'] > #ico {
		content: var(--drv-overridenNew-url);
	}

	#st[data-drv-state='overridenDone'] > #ico {
		content: var(--drv-overridenDone-url);
	}

	#st[data-drv-state='overridenDirty'] > #ico {
		content: var(--drv-overridenDirty-url);
	}

	#st[data-drv-state='createdNew'] > #ico {
		content: var(--drv-createdNew-url);
	}

	#st[data-drv-state='createdDone'] > #ico {
		content: var(--drv-createdDone-url);
	}

	#st[data-drv-state='createdDirty'] > #ico {
		content: var(--drv-createdDirty-url);
	}


`);

customElements.define('wsp-rib-drv', RibbonDrv);

/**
 * Critère de recherche DRV : ItemCritDrvState
 *    <wsp-itemcrit-drv-state/>
 */
export class ItemCritDrvState extends UiCritBase {

	static AREA = new UiCritArea("wsp-itemcrit-drv-state")
		.setGroup("item")
		.setLabel((ctx) => {
			const wspDefProps = ctx.reg.env.wsp.wspDefProps;
			const isWspL10n = WSP_L10N.isL10n(wspDefProps);
			return isWspL10n ? "Propriété de traduction" : "Propriété de dérivation";
		})
		.setBuildAbstract((xml: Element, ctx: OUiCritInit): HTMLElement => {
			const wspDefProps = ctx.reg.env.wsp.wspDefProps;
			const isWspL10n = WSP_L10N.isL10n(wspDefProps);
			const statesCodesList = xml.hasAttribute("drvStates") ? xml.getAttribute("drvStates").split(" ") as EDrvState[] : [];
			const statesLabelsList: string[] = [];
			statesCodesList.forEach(entry => statesLabelsList.push(WSP_DRV.getDrvStateLabel(entry, isWspL10n)))

			if (statesLabelsList.length > 0) {
				if (statesLabelsList.length == 1) {
					const statesList = <span class="critVal">{statesLabelsList[0]}</span>;
					return <span class="crit">{isWspL10n ? "Propriété de traduction" : "Propriété de dérivation"} {statesList}</span>;
				} else {
					const returnElt = <span class="crit">{isWspL10n ? "Propriétés de traduction" : "Propriétés de dérivation"}</span>;
					returnElt.title = "'" + statesLabelsList.join("', ou '") + "'";
					return returnElt;
				}
				/*
				let statesList = <div/>;
				statesLabelsList.forEach((entry, index) => {
					if(index > 0)
						statesList.appendChild(<span> ou </span>);
					statesList.appendChild(<span class="critVal">{entry}</span>);
				});
				return <span class="crit">Propriété de dérivation {statesList}</span>;
				*/
			}
		});

	protected _notOverridenBtn: ButtonToggle;

	protected _notOverridenDoneBtn: ButtonToggle;

	protected _notOverridenDirtyBtn: ButtonToggle;

	protected _overridenNewBtn: ButtonToggle;

	protected _overridenDoneBtn: ButtonToggle;

	protected _overridenDirtyBtn: ButtonToggle;

	protected _createdNewBtn: ButtonToggle;

	protected _createdDoneBtn: ButtonToggle;

	protected _createdDirtyBtn: ButtonToggle;

	get notOverriden(): boolean {return this._notOverridenBtn.toggleOn}

	set notOverriden(state: boolean) {this._notOverridenBtn.toggleOn = state}

	get notOverridenDone(): boolean {return this._notOverridenDoneBtn.toggleOn}

	set notOverridenDone(state: boolean) {this._notOverridenDoneBtn.toggleOn = state}

	get notOverridenDirty(): boolean {return this._notOverridenDirtyBtn.toggleOn}

	set notOverridenDirty(state: boolean) {this._notOverridenDirtyBtn.toggleOn = state}

	get overridenNew(): boolean {return this._overridenNewBtn.toggleOn}

	set overridenNew(state: boolean) {this._overridenNewBtn.toggleOn = state}

	get overridenDone(): boolean {return this._overridenDoneBtn.toggleOn}

	set overridenDone(state: boolean) {this._overridenDoneBtn.toggleOn = state}

	get overridenDirty(): boolean {return this._overridenDirtyBtn.toggleOn}

	set overridenDirty(state: boolean) {this._overridenDirtyBtn.toggleOn = state}

	get createdNew(): boolean {return this._createdNewBtn.toggleOn}

	set createdNew(state: boolean) {this._createdNewBtn.toggleOn = state}

	get createdDone(): boolean {return this._createdDoneBtn.toggleOn}

	set createdDone(state: boolean) {this._createdDoneBtn.toggleOn = state}

	get createdDirty(): boolean {return this._createdDirtyBtn.toggleOn}

	set createdDirty(state: boolean) {this._createdDirtyBtn.toggleOn = state}

	async initFromXmlCrit(xml: Element): Promise<this> {
		const states = xml.hasAttribute("drvStates") ? xml.getAttribute("drvStates").split(" ") : [];
		this.notOverriden = states.indexOf("notOverriden") > -1;
		this.notOverridenDone = states.indexOf("notOverridenDone") > -1;
		this.notOverridenDirty = states.indexOf("notOverridenDirty") > -1;
		this.overridenNew = states.indexOf("overridenNew") > -1;
		this.overridenDone = states.indexOf("overridenDone") > -1;
		this.overridenDirty = states.indexOf("overridenDirty") > -1;
		this.createdNew = states.indexOf("createdNew") > -1;
		this.createdDone = states.indexOf("createdDone") > -1;
		this.createdDirty = states.indexOf("createdDirty") > -1;
		return this;
	}

	buildCrit(): ISearchCrit | undefined {
		const states: EDrvState[] = [];
		if (this.notOverriden) states.push("notOverriden");
		if (this.notOverridenDone) states.push("notOverridenDone");
		if (this.notOverridenDirty) states.push("notOverridenDirty");
		if (this.overridenNew) states.push("overridenNew");
		if (this.overridenDone) states.push("overridenDone");
		if (this.overridenDirty) states.push("overridenDirty");
		if (this.createdNew) states.push("createdNew");
		if (this.createdDone) states.push("createdDone");
		if (this.createdDirty) states.push("createdDirty");
		return new SearchDrvStates(states);
	}

	protected _initialize(init: OUiCritInit): void {
		super._initialize(init);
		const sr = this.shadowRoot;

		const wspDefProps = this.reg.env.wsp.wspDefProps;
		const isWspL10n = WSP_L10N.isL10n(wspDefProps);

		const critHead = sr.appendChild(<div class="critHead">
			<span class="critTitle">{isWspL10n ? "Propriété de traduction" : "Propriété de dérivation"}</span>
			{this.insertAlternativesBtn(init)}
		</div>);

		const gridContainer = sr.appendChild(<div class="gridContainer"/>);

		// Ligne d'entête
		gridContainer.appendChild(<div/>);
		gridContainer.appendChild(<Button onclick={this.toggleColumn} icon="/@skin@/wsp/objects/drvState/new.svg" data-column="new" title="Items jamais marqués 'achevés'" ui-context="bar"/>);
		gridContainer.appendChild(<Button onclick={this.toggleColumn} icon="/@skin@/wsp/objects/drvState/done.svg" data-column="done" title="Items marqués 'achevés'" ui-context="bar"/>);
		gridContainer.appendChild(<Button onclick={this.toggleColumn} icon="/@skin@/wsp/objects/drvState/dirty.svg" data-column="dirty" title="Items à (re)contrôler" ui-context="bar"/>);

		// Ligne 'notOverriden'
		gridContainer.appendChild(<Button onclick={this.toggleRow} label={isWspL10n ? "Non traduits" : "Non surchargés"} data-row="notOverriden"
																			title={isWspL10n ? "Items non traduits dans cet atelier" : "Items non surchargés dans cet atelier"} ui-context="bar"/>);
		this._notOverridenBtn = <ButtonToggle onclick={this.toggleButton} icon="/@skin@/wsp/objects/drvState/notOverriden.svg" class="notOverriden"
																					title={isWspL10n ? "Items non traduits, jamais marqués 'achevés'" : "Items non surchargés, jamais marqués 'achevés'"}/> as ButtonToggle;
		this._notOverridenDoneBtn = <ButtonToggle onclick={this.toggleButton} icon="/@skin@/wsp/objects/drvState/notOverridenDone.svg" class="notOverridenDone"
																							title={isWspL10n ? "Items non traduits, marqués 'achevés'" : "Items non surchargés, marqués 'achevés'"}/> as ButtonToggle;
		this._notOverridenDirtyBtn = <ButtonToggle onclick={this.toggleButton} icon="/@skin@/wsp/objects/drvState/notOverridenDirty.svg" class="notOverridenDirty"
																							 title={isWspL10n ? "Items non traduits, à contrôler" : "Items non surchargés, à contrôler"} aria-pressed="true"/> as ButtonToggle;
		gridContainer.append(<div class="bg">{this._notOverridenBtn}</div>, <div class="bg">{this._notOverridenDoneBtn}</div>, <div class="bg">{this._notOverridenDirtyBtn}</div>);

		// Ligne 'overriden'
		gridContainer.appendChild(<Button onclick={this.toggleRow} label={isWspL10n ? "Traduits" : "Surchargés"} data-row="overriden"
																			title={isWspL10n ? "Items traduits dans cet atelier" : "Items surchargés dans cet atelier"}
																			ui-context="bar"/>);
		this._overridenNewBtn = <ButtonToggle onclick={this.toggleButton} icon="/@skin@/wsp/objects/drvState/overridenNew.svg" class="overridenNew"
																					title={isWspL10n ? "Items traduits, jamais marqués 'achevés'" : "Items surchargés, jamais marqués 'achevés'"}/> as ButtonToggle;
		this._overridenDoneBtn = <ButtonToggle onclick={this.toggleButton} icon="/@skin@/wsp/objects/drvState/overridenDone.svg" class="overridenDone"
																					 title={isWspL10n ? "Items traduits, marqués 'achevés'" : "Items surchargés, marqués 'achevés'"}/> as ButtonToggle;
		this._overridenDirtyBtn = <ButtonToggle onclick={this.toggleButton} icon="/@skin@/wsp/objects/drvState/overridenDirty.svg" class="overridenDirty" title={isWspL10n ? "Items traduits, à contrôler" : "Items surchargés, à contrôler"}
																						aria-pressed="true"/> as ButtonToggle;
		gridContainer.append(<div class="bg">{this._overridenNewBtn}</div>, <div class="bg">{this._overridenDoneBtn}</div>, <div class="bg">{this._overridenDirtyBtn}</div>);

		// Ligne 'notOverriden'
		gridContainer.appendChild(<Button onclick={this.toggleRow} label="Locaux" data-row="created" title="Items créés spécifiquement dans cet atelier"
																			ui-context="bar"/>);
		this._createdNewBtn = <ButtonToggle onclick={this.toggleButton} icon="/@skin@/wsp/objects/drvState/createdNew.svg" class="created" title="Items spécifiques à cet atelier, jamais marqués 'achevés'"/> as ButtonToggle;
		this._createdDoneBtn = <ButtonToggle onclick={this.toggleButton} icon="/@skin@/wsp/objects/drvState/createdDone.svg" class="createdDone" title="Items spécifiques à cet atelier, marqués 'achevés'"/> as ButtonToggle;
		this._createdDirtyBtn = <ButtonToggle onclick={this.toggleButton} icon="/@skin@/wsp/objects/drvState/createdDirty.svg" class="createdDirty" title="Items spécifiques à cet atelier, à contrôler" aria-pressed="true"/> as ButtonToggle;
		gridContainer.append(<div class="bg">{this._createdNewBtn}</div>, <div class="bg">{this._createdDoneBtn}</div>, <div class="bg">{this._createdDirtyBtn}</div>);

	}

	private toggleButton(this: ButtonToggle, ev?: Event): void {
		const me = DOMSH.findHost(this) as ItemCritDrvState;
		this.toggleOn = !this.toggleOn;
		me.onChange();
	}

	private toggleRow(this: Button): void {
		const me = DOMSH.findHost(this) as ItemCritDrvState;
		const row = this.getAttribute("data-row");
		if (row == "notOverriden") {
			const isSelected = me.notOverriden || me.notOverridenDone || me.notOverridenDirty;
			me.notOverriden = me.notOverridenDone = me.notOverridenDirty = !isSelected;
		} else if (row == "overriden") {
			const isSelected = me.overridenNew || me.overridenDone || me.overridenDirty;
			me.overridenNew = me.overridenDone = me.overridenDirty = !isSelected;
		} else if (row == "created") {
			const isSelected = me.createdNew || me.createdDone || me.createdDirty;
			me.createdNew = me.createdDone = me.createdDirty = !isSelected;
		}
		me.onChange();
	}

	private toggleColumn(this: Button): void {
		const me = DOMSH.findHost(this) as ItemCritDrvState;
		const column = this.getAttribute("data-column");
		if (column == "new") {
			const isSelected = me.notOverriden || me.overridenNew || me.createdNew;
			me.notOverriden = me.overridenNew = me.createdNew = !isSelected;
		} else if (column == "done") {
			const isSelected = me.notOverridenDone || me.overridenDone || me.createdDone;
			me.notOverridenDone = me.overridenDone = me.createdDone = !isSelected;
		} else if (column == "dirty") {
			const isSelected = me.notOverridenDirty || me.overridenDirty || me.createdDirty;
			me.notOverridenDirty = me.overridenDirty = me.createdDirty = !isSelected;
		}
		me.onChange();
	}
}

REG.reg.registerSkin('wsp-itemcrit-drv-state', 1, /* language=CSS */ `
	.gridContainer {
		display: grid;
		grid-template-columns: 9em repeat(3, 2.5em);
		grid-template-rows: auto;
	}

	.bg {
		padding: .2em;
		background-color: var(--form-bgcolor);
		--pressed-bgcolor: rgba(255, 255, 0, 0.2);
	}
`);

customElements.define("wsp-itemcrit-drv-state", ItemCritDrvState);


/**
 * Init du registre spécifique à un atelier de type DRV
 * 		init du registre **ui** (par app)
 */
export function initDrvReg(reg: IReg<IWspUiEnv>) {
	const wspDefProps = reg.env.wsp.wspDefProps;
	const isWspL10n = WSP_L10N.isL10n(wspDefProps);

	reg.addToList("wspApp:tools:rb", "drvChanges", 1, new NavigatorArea("drvChanges")
			.setLabel(() => "Reste à faire")
			.setDescription(isWspL10n ? "Liste des items à traduire/contrôler" : "Liste des items à dériver/contrôler")
			.setIcon("/@skin@/wsp/views/navigator/workDrv.svg")
			.setEmptyTree((n) => <c-msg label="Aucun item à contrôler" level="info"/>)
			.setBuildFacets(async (nav, fields) => new NavigatorFacetItDrv(fields).initFacet(true, true, isWspL10n, true, true))
			.setActionsLists(["actions:wspApp:navigator", "actions:wsp:shortDesc"])
			.setAccelKeysLists(["accelkeys:wspApp:navigator", "accelkeys:wsp:shortDesc"])
		, 10);

	const drvColDef = new GridColDef("drv")
		.setFlex("1em", 0, 0)
		.setCellBuilder(new CellBuilderDrvFlag("drvState", isWspL10n))
		.setSkin("wsp-explorer/grid/drv")
		.setLabel("")
		.setDescription(isWspL10n ? "État de la traduction" : "État du calque de dérivation");

	reg.registerSvc("column.drv", 1, drvColDef);
	reg.addSvcToList('columns:wspExplorer:secondaryCols', 'drv', 1, "column.drv", 10);
	reg.addSvcToList("columns:netItems:secondaryCols", 'drv', 1, "column.drv", 10);

	reg.addSvcToList("columns:wspApp:searches:item", "drv", 1, "column.drv");

	reg.addToList("columns:wspApp:searches-export:item", "drv", 1, new SearchExportColumn<IRegPointer<IWspUiEnv>>('drv').setColDef(
		new SearchFuncTranslateStr("drvState").setDict(() => {
			const states: { [key in EDrvState]: string } = {
				erased: WSP_DRV.getDrvStateLabel("erased", isWspL10n),
				notOverriden: WSP_DRV.getDrvStateLabel("notOverriden", isWspL10n),
				notOverridenDone: WSP_DRV.getDrvStateLabel("notOverridenDone", isWspL10n),
				createdDone: WSP_DRV.getDrvStateLabel("createdDone", isWspL10n),
				overridenDone: WSP_DRV.getDrvStateLabel("overridenDone", isWspL10n),
				createdNew: WSP_DRV.getDrvStateLabel("createdNew", isWspL10n),
				overridenNew: WSP_DRV.getDrvStateLabel("overridenNew", isWspL10n),
				notOverridenDirty: WSP_DRV.getDrvStateLabel("notOverridenDirty", isWspL10n),
				createdDirty: WSP_DRV.getDrvStateLabel("createdDirty", isWspL10n),
				overridenDirty: WSP_DRV.getDrvStateLabel("overridenDirty", isWspL10n),
				createdNotComputed: WSP_DRV.getDrvStateLabel("createdNotComputed", isWspL10n),
				notComputed: WSP_DRV.getDrvStateLabel("notComputed", isWspL10n),
			};
			return states;
		})).setLabel(isWspL10n ? "Calque de traduction : état" : "Calque de dérivation : état").setExportStatus(ESearchExportColumnStatus.exportable));

	function addSrcSvcAction(reg: IReg<IWspUiEnv>, svc: string, sortKey?: number) {
		reg.addSvcToList("actions:wsp:shortDesc", svc, 1, svc, sortKey);
		// reg.addToList("actions:wspApp:explorer", act.getId(), 1, act, sortKey);
		// reg.addToList("actions:item:burger", act.getId(), 1, act, sortKey);
		// reg.addToList("actions:searchItem:shortDesc:item", act.getId(), 1, act, sortKey);
	}

	addSrcSvcAction(reg, 'drv/deleteDrvOvrAction', -2);
	addSrcSvcAction(reg, 'drv/markDrvDoneAction', -1);

	reg.addToList("ribbon:item", "drv", 1, RibbonDrv, 20);

	REG.reg.registerSvc("wsp-itemcrit-drv-state", 1, ItemCritDrvState.AREA);
	reg.addSvcToList("wsp.crit.items", "wsp-itemcrit-drv-state", 1, "wsp-itemcrit-drv-state");
}


class NavigatorFacetItDrv extends NavigatorFacetText {

	statesNew: boolean
	statesDirty: boolean
	showTextFilter: boolean
	showStateFilter: boolean

	protected isWspL10n: boolean

	protected statesNewCheck?: ButtonToggle
	protected statesDirtyCheck?: ButtonToggle

	initFacet(statesNew: boolean, statesDirty: boolean, isWspL10n = false, showStateFilter = true, showTextFilter = false): this {
		this.statesNew = statesNew;
		this.statesDirty = statesDirty;
		this.showTextFilter = showTextFilter;
		this.showStateFilter = showStateFilter;
		this.isWspL10n = isWspL10n;
		return this;
	}

	buildUiFacets(nav: Navigator, lastDatas: JLastDatas | null) {
		const root = this.initRoot(nav);
		root.appendChild(<div id="itDrvCtn">{this.buildDrvInput(nav, lastDatas)}{nav.navigatorBtns}</div>);
		if (this.showTextFilter) root.appendChild(this.buildTextInput(nav, lastDatas));
	}

	buildLastDatas(parentLastDatas: JLastDatas) {
		super.buildLastDatas(parentLastDatas);
		if (!this.statesNewCheck?.toggleOn) (parentLastDatas as JLDFacetItDrv).statesNew = false;
		if (!this.statesDirtyCheck?.toggleOn) (parentLastDatas as JLDFacetItDrv).statesDirty = false;
	}

	protected initSkin() {
		this.skin = ["wsp-navigator/facetText", "wsp-navigator/facetItDrv"];
	}

	protected buildDrvInput(nav: Navigator, lastDatas: JLDFacetItDrv | null): HTMLElement | undefined {
		if (this.showStateFilter) {
			const me = this;
			this.statesNewCheck = <ButtonToggle
				onclick={function (this: ButtonToggle, ev?: Event) {
					this.toggleOn = !this.toggleOn;
					me.onChange.call(this, ev)
				}}
				ellipsis="true"
				icon="/@skin@/wsp/objects/drvState/new.svg"
				label="non achevée"
				title={this.isWspL10n ? "Afficher les items à traduire" : "Afficher les items à dériver"}
				aria-pressed={lastDatas?.statesNew !== false}/> as ButtonToggle;
			this.statesDirtyCheck = <ButtonToggle
				onclick={function (this: ButtonToggle, ev?: Event) {
					this.toggleOn = !this.toggleOn;
					me.onChange.call(this, ev)
				}}
				ellipsis="true"
				icon="/@skin@/wsp/objects/drvState/dirty.svg"
				label="à contrôler"
				title={this.isWspL10n ? "Afficher les items déjà traduits, mais à contrôler" : "Afficher les items déjà dérivés, mais à contrôler"}
				aria-pressed={lastDatas?.statesDirty !== false}/> as ButtonToggle;
			const ctn = <div id="itDrv">
				<span>{this.isWspL10n ? "Traduction :" : "Dérivation :"}</span>
				{this.statesNewCheck}
				{this.statesDirtyCheck}
			</div>;
			return ctn;
		} else
			return <div id="itDrv"/>;
	}

	protected getCriterions(): Element | Element[] | undefined {
		let searchCrit = new SearchDrvStates(["" as any]);
		if (this.statesNewCheck?.toggleOn) searchCrit.drvStates.push("notOverriden", "overridenNew", "createdNew");
		if (this.statesDirtyCheck?.toggleOn) searchCrit.drvStates.push("notOverridenDirty", "overridenDirty", "createdDirty");
		return LANG.pushIfDefined([searchCrit.toDom()], this.getTextCriterion());
	}
}

interface JLDFacetItDrv {
	statesNew?: boolean
	statesDirty?: boolean
}

REG.reg.registerSkin('wsp-navigator/facetItDrv', 1, /* language=CSS */ `
	#itDrvCtn, #itDrv {
		flex: 1;
		display: flex;
		min-width: 0;
		min-height: 0;
	}

	#itDrv {
		padding: 3px;
	}

	#itDrv > span {
		white-space: nowrap;
	}


	c-button-toggle {
		margin-inline-end: .5em;
	}

	#txt {
		flex: 0;
	}
`);